import {EL_COL_TYPE_IGNORE, EL_COL_TYPE_TRANSLATION, EL_SEMANTIC_CONCEPT_EXISTING, EL_SEMANTIC_CONCEPT_NEW } from "../constants";

const isSemanticColumn = (column) => {
    return column.type !== EL_COL_TYPE_IGNORE && column.type !== EL_COL_TYPE_TRANSLATION
}

const newConceptHasError = (column) => {
    if (column.semanticDefinition.conceptType === EL_SEMANTIC_CONCEPT_NEW) {
        if (Object.keys(column.semanticDefinition.newConcept).length === 0) {
            return true;
        } else {
            let hasError = false;
            Object.keys(column.semanticDefinition.newConcept).forEach(lang => {
                if ((column.semanticDefinition.newConcept[lang] || "").length === 0) {
                    hasError = true;
                }
            });
            return hasError;
        }
    }
    return false;
}

const conceptHasError = (column) => {
    if (column.semanticDefinition.conceptType === EL_SEMANTIC_CONCEPT_EXISTING) {
        return column.semanticDefinition.conceptSchema === null || column.semanticDefinition.concept === null;
    }
    return false;
}

export const semanticIsWellDefined = (structureColumns) => {

    return !(structureColumns || []).some(column => 
        isSemanticColumn(column) &&
        (column.semanticDefinition.conceptType === null || newConceptHasError(column) || conceptHasError(column))      
    );
}


// WEBPACK FOOTER //
// ./src/components/easy-loading/semantic-step/utils.js